module.exports = __webpack_public_path__ + "img/casbee-pulldown-disabled.43070eb9.svg";